import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { useEventTracker } from "hooks/useEventTracker";
import { REQUEST_LOCATION } from "redux/reducers/location";
import { getFormattedLocation } from "redux/selectors/location";
import { Action, Category } from "utils/trackEvent";

type Props = {
  subtitle: string;
  changeLocation: boolean;
  title: string;
  referrer?: string | null;
};
const Subtitle = ({
  subtitle,
  title,
  changeLocation,
  referrer = null,
}: Props) => {
  const dispatch = useDispatch();
  const formattedLocation = useSelector(getFormattedLocation);
  const { publishEvent } = useEventTracker();

  const onClickHandler = () => {
    dispatch({ type: REQUEST_LOCATION });

    publishEvent({
      action: Action.click,
      category: Category.carousel,
      label:
        referrer === "strainDispensaryCarousel"
          ? "strain page dispensary carousel change location"
          : title,
    });
  };

  return (
    <>
      {subtitle}
      {changeLocation && (
        <>
          {" "}
          <button
            onClick={onClickHandler}
            className="font-bold pointer text-green underline"
            data-testid="section-wrapper-location-change"
          >
            {`${formattedLocation}` || "your city"}
          </button>
        </>
      )}
    </>
  );
};

export default Subtitle;
